export default {
  methods: {
    t(str, fallbackStr) {
      // use `$te` and `$t
      return this.$t && this.$te ?
        this.$te(str) && this.$t(str).length ?
        this.$t(str) :
        fallbackStr :
        fallbackStr ?
        fallbackStr :
        str
    }
  },
}